<template>
  <div class="general-ledger-view2-multi-currency">
    <div class="section operations" style="margin-bottom:2px;">
      <el-form inline style="margin-bottom:-12px;">
        <!--会计期间-->
        <el-form-item :label="$t('CargoMsg.Cargo_FiscalPeriod')">
          <el-select ref="fromFPRef" v-model="form.fromFP" style="width: 120px;" no="1">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_To')">
          <el-select v-model="form.toFP" style="width: 120px;" no="2">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--起始科目-->
        <el-form-item :label="$t('CargoMsg.Cargo_StartingAccountTitle')">
          <el-select ref="accountTitleRef" v-model="form.fromAccountTitle" style="width: 300px;" :filterable="true" :clearable="true" no="3">
            <el-option
              v-for="(item,index) in accountTitleCollection"
              :key="index"
              :label="accountTitleLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--结束科目-->
        <el-form-item :label="$t('CargoMsg.Cargo_ClosureTitleOfAccount')">
          <el-select ref="accountTitleRef" v-model="form.toAccountTitle" style="width: 300px;" :filterable="true" :clearable="true" no="4">
            <el-option
              v-for="(item,index) in accountTitleCollection"
              :key="index"
              :label="accountTitleLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <br>
        <!--币种-->
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select v-model="form.sourceCurrency" style="width: 100px;" no="5">
            <el-option
              v-for="item in usedCurrencyCollection"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <!--显示明细科目-->
          <el-checkbox v-model="form.showItems" :label="$t('CargoMsg.Cargo_ShowDetailedTitles')" no="6" />
          <!--含期末调汇分录-->
          <el-checkbox v-model="form.showAdjustRateEntry" :label="$t('CargoMsg.Cargo_ShowAdjustRateEntry')" no="7" />
          <!--查询-->
          <el-button class="el-margin" type="primary" style="margin-left: 20px;" no="8" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :row-data="rowData"
        :auto-fit-content="false"
        style="height: 800px;"
        no="9"
      />
    </div>
  </div>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as accountingEntryApi from '@/api/financeManage/accountingEntry'
import { getLoading } from '@/utils/utilBaseElement'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'GeneralLedgerView2MultiCurrency',
  components: { cargoAdvanceSelect },
  props: {
    accountSet: { type: Object, default: null },
    usedCurrencyCollection: { type: Array, default: null }
  },
  data() {
    return {
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          minWidth: 80,
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
              field: 'ACCOUNT_TITLE',
              width: 100
            }
          ]
        }, {
          headerName: '',
          field: '',
          width: 150,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AccountTitleName'),
              field: 'ACCOUNT_TITLE_NAME',
              width: 150
            }
          ]
        }, {
          headerName: '',
          field: '',
          width: 90,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Periods'),
              field: 'FISCALPERIOD',
              width: 90
            }
          ]
        }, {
          headerName: '',
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Abstract'),
              field: 'SUMMARY',
              width: 240
            }
          ]
        }, {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Currency'),
              field: 'SOURCE_CURRENCY',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        }, {
          headerName: '\u3000\u3000\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_DebitAmountCN'),
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'DEBIT_USD',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'DEBIT_RMB',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_CreditAmountCN'),
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'CREDIT_USD',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'CREDIT_RMB',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Direction'),
              field: 'DEBIT_CREBIT',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_Balance'),
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'BALANCE_USD_SUM',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'BALANCE_RMB_SUM',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        }
      ],
      columnDefsRMB: [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          field: 'ACCOUNT_TITLE',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleName'),
          field: 'ACCOUNT_TITLE_NAME',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Periods'),
          field: 'FISCALPERIOD',
          width: 90
        }, {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 240
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 80,
          cellStyle: { textAlign: 'center' }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountCN'),
          field: 'DEBIT_RMB',
          width: 120,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountCN'),
          field: 'CREDIT_RMB',
          width: 120,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Direction'),
          field: 'DEBIT_CREBIT',
          width: 80,
          cellStyle: { textAlign: 'center' }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Balance'),
          field: 'BALANCE_RMB_SUM',
          width: 120,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }
      ],
      excelColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          field: 'ACCOUNT_TITLE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleName'),
          field: 'ACCOUNT_TITLE_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Periods'),
          field: 'FISCALPERIOD',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountSource'),
          field: 'DEBIT_USD',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountLocal'),
          field: 'DEBIT_RMB',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountSource'),
          field: 'CREDIT_USD',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountLocal'),
          field: 'CREDIT_RMB',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Direction'),
          field: 'DEBIT_CREBIT',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BalanceSource'),
          field: 'BALANCE_USD_SUM',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceLocal'),
          field: 'BALANCE_RMB_SUM',
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }
      ],
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      fpSelectDataProvider: [],
      form: {
        fromFP: '',
        toFP: '',
        fromAccountTitle: null,
        toAccountTitle: null,
        sourceCurrency: '',
        showItems: false,
        showAdjustRateEntry: false
      }
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 初始会计期间
    initialFiscalPeriod() {
      return this.accountSet ? this.accountSet.initialFiscalPeriod : null
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    // 部门编码映射
    mappingDepartments() {
      return this.accountSet ? this.accountSet.mappingDepartments : []
    },
    // 凭证类型
    accountingDocumentTypes() {
      return this.accountSet ? this.accountSet.accountingDocumentType : []
    },
    isExt() {
      return Number(cache.config.get('ext')) === 1
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
        if (this.currentFiscalPeriod) {
          this.form.fromFP = this.currentFiscalPeriod.uuid
          this.form.toFP = this.currentFiscalPeriod.uuid
        }
        this.form.sourceCurrency = this.usedCurrencyCollection[0]
      }
    }
  },
  created() {
    if (this.currentFiscalPeriod) {
      this.form.fromFP = this.currentFiscalPeriod.uuid
      this.form.toFP = this.currentFiscalPeriod.uuid
    }
    this.form.sourceCurrency = this.usedCurrencyCollection[0]
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.N0Year0Period', [data.year, data.month])
      }
      return ''
    },
    numberFormat(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      const obj = {}
      Object.assign(obj, this.form)
      obj.accountSet = this.accountSet.uuid
      obj.year = this.currentFiscalPeriod.year
      const fromFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      const toFP = this.fiscalPeriods.find(fp => fp.uuid === this.form.toFP)
      if (fromFP) {
        obj.fromMonth = fromFP.month
        obj.yearSearch = fromFP.year
      } else {
        obj.fromMonth = this.currentFiscalPeriod.month
      }
      if (toFP) {
        obj.toMonth = toFP.month
        obj.yearSearch = toFP.year
      } else {
        obj.toMonth = this.currentFiscalPeriod.month
      }
      // 相同年
      if (fromFP && fromFP.year && toFP && toFP.year && fromFP.year !== toFP.year) {
        this.$refs.fromFPRef.focus()
        this.$message.warning(this.$t('CargoMsg.Cargo_PSFPOTSY'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }

      if (this.form.fromAccountTitle) {
        const accountTitle = this.accountTitleCollection.find(title => title.uuid === this.form.fromAccountTitle)
        obj.fromAccountTitle = accountTitle ? accountTitle.accountTitle : ''
      }
      if (this.form.toAccountTitle) {
        const accountTitle = this.accountTitleCollection.find(title => title.uuid === this.form.toAccountTitle)
        obj.toAccountTitle = accountTitle ? accountTitle.accountTitle : ''
      }

      if (this.form.sourceCurrency !== this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency')) {
        obj.sourceCurrency = this.form.sourceCurrency
      } else {
        obj.sourceCurrency = undefined
      }
      if (!this.form.showItems) {
        obj.showItems = undefined
      }
      // 显示期末调汇分录
      obj.showAdjustRateEntry = this.form.showAdjustRateEntry
      this.setColumnVisible()
      const loading = getLoading()
      accountingEntryApi.getGeneralLedgerChart2ByMultiCurrency({ conditionMap: obj }).then(resp => {
        this.rowData = resp.data
      }).finally(() => loading.close())
    },
    setColumnVisible() {
      this.gridOptions.api.setColumnDefs([])
      if (this.form.sourceCurrency !== this.accountSet.localCurrency) {
        this.gridOptions.api.setColumnDefs(this.columnDefs)
      } else {
        this.gridOptions.api.setColumnDefs(this.columnDefsRMB)
      }
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel('总账', this.rowData, columnDefs)
    }
  }
}
</script>

<style scoped>
  .el-margin{
    margin: 0 10px 5px 5px;
  }
</style>
